export default __webpack_public_path__ + "static/media/OrgChart.5fa97b6b.jpg";